import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "engines-health",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Monitor the operating state of configured engines.",
    domain: "engines",
    visual: "Status grid",
    purposes: ["live"],
    audiences: ["analyst"],
  },
  layout: { kind: "content", skeleton: "cards" },
  defaultLayoutClassName: "col-span-12",
};
